
export default function HeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-blue-600 to-purple-600 text-white py-20">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20diverse%20team%20working%20together%20in%20modern%20office%20space%20with%20laptops%20and%20documents%2C%20collaborative%20business%20environment%2C%20bright%20lighting%2C%20corporate%20setting%2C%20teamwork%20and%20innovation%20atmosphere&width=1920&height=800&seq=about-hero&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-purple-900/90"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            About Cofunnels
          </h1>
          <p className="text-xl sm:text-2xl text-blue-100 mb-8 leading-relaxed">
            We're passionate funnel experts helping businesses transform their online presence into revenue-generating machines.
          </p>
          <div className="flex flex-wrap gap-6">
            <div className="flex items-center">
              <i className="ri-trophy-line text-3xl text-yellow-400 mr-3"></i>
              <div>
                <div className="text-2xl font-bold">500+</div>
                <div className="text-blue-200">Projects Completed</div>
              </div>
            </div>
            <div className="flex items-center">
              <i className="ri-team-line text-3xl text-green-400 mr-3"></i>
              <div>
                <div className="text-2xl font-bold">98%</div>
                <div className="text-blue-200">Client Satisfaction</div>
              </div>
            </div>
            <div className="flex items-center">
              <i className="ri-calendar-line text-3xl text-purple-300 mr-3"></i>
              <div>
                <div className="text-2xl font-bold">5+</div>
                <div className="text-blue-200">Years Experience</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}